// Import model
import { UpdatePaymentTermsRequest } from '../models/UpdatePaymentTermsRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for UpdatePaymentTermsRequest - handles JSON serialization and deserialization with type validation
 */
export class UpdatePaymentTermsRequestSerializer {
  /**
   * Deserializes a JSON string into a UpdatePaymentTermsRequest instance
   */
  static deserialize(json: string): UpdatePaymentTermsRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a UpdatePaymentTermsRequest instance
   */
  static fromObject(obj: any): UpdatePaymentTermsRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to UpdatePaymentTermsRequest');
    }


    const instance: UpdatePaymentTermsRequest = {
      discount: obj['discount'] as number | undefined,
      downPayment: obj['downPayment'] as number | undefined,
      downPaymentPercentage: obj['downPaymentPercentage'] as number | undefined,
      frequency: obj['frequency'] as string | undefined,
      installments: obj['installments'] as number | undefined,
      interestRatePercentage: obj['interestRatePercentage'] as number | undefined,
      isActive: obj['isActive'] as boolean | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of UpdatePaymentTermsRequest instances
   */
  static deserializeArray(json: string): UpdatePaymentTermsRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a UpdatePaymentTermsRequest instance to a JSON string
   */
  static serialize(instance: UpdatePaymentTermsRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a UpdatePaymentTermsRequest instance to a plain object
   */
  static toObject(instance: UpdatePaymentTermsRequest): any {
    return {
      'discount': instance.discount,
      'downPayment': instance.downPayment,
      'downPaymentPercentage': instance.downPaymentPercentage,
      'frequency': instance.frequency,
      'installments': instance.installments,
      'interestRatePercentage': instance.interestRatePercentage,
      'isActive': instance.isActive,
    };
  }

  /**
   * Serializes an array of UpdatePaymentTermsRequest instances to a JSON string
   */
  static serializeArray(instances: UpdatePaymentTermsRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
